<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<div class="EduTaxRebateWidgetGovMB__propertySummary">
	<!-- <div class="EduTaxRebateWidgetGovMB__propertySummary--heading" v-html="$t('summaryTitle')"></div> -->
	<div class="EduTaxRebateWidgetGovMB__propertySummary--totalsHeading" v-html="$t('summaryTotalsHeading')"></div>
	<div class="EduTaxRebateWidgetGovMB__propertySummary--row">
	<div class="EduTaxRebateWidgetGovMB__propertySummary--leftColumn">

		<div v-for="(p,x) in value" class="EduTaxRebateWidgetGovMB__propertySummary--property" :key="`EduTaxRebateWidgetGovMB__propertySummary`+x">
			<div class="EduTaxRebateWidgetGovMB__propertySummary--propertyHeader" v-html="getPropertyHeader(x)"></div>
			<template v-for="(a, y) in p.assessment">
				<div class="EduTaxRebateWidgetGovMB__propertySummary--assessment" :key="`EduTaxRebateWidgetGovMB__propertySummary`+x+'_'+y">
					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
							<span class="EduTaxRebateWidgetGovMB__propertySummary--classNum" v-html="(y+1).leftZeroPad(2)"></span>
							<span class="EduTaxRebateWidgetGovMB__propertySummary--class" v-html="$t('class.'+a.classType)"></span>
						</div>
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
						</div>
					</div>

					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
							<span class="EduTaxRebateWidgetGovMB__propertySummary--label" v-html="$t('portionedAssessment')"></span>
						</div>
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
							<div class="EduTaxRebateWidgetGovMB__propertySummary--value" v-html="getMoneyFormat(a.portionedAssessment.value)"></div>
						</div>
					</div>

					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
							<span class="EduTaxRebateWidgetGovMB__propertySummary--label EduTaxRebateWidgetGovMB__propertySummary--labelSchoolDivisionMillRate" v-html="$t('schoolDivisionMillRate')"></span>
						</div>
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
							<div class="EduTaxRebateWidgetGovMB__propertySummary--value" v-html="getZeroIfNull(a.schoolDivisionMillRate.value)"></div>
						</div>
					</div>

					<div v-if="a.classType == 'otherProperty'" class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
							<span class="EduTaxRebateWidgetGovMB__propertySummary--label" v-html="$t('educationSupportLevy')"></span>
						</div>
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
							<div class="EduTaxRebateWidgetGovMB__propertySummary--value" v-html="getZeroIfNull(a.educationSupportLevy.value)"></div>
						</div>
					</div>

					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
							<span class="EduTaxRebateWidgetGovMB__propertySummary--label" v-html="$t('schoolTax')"></span>
						</div>
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
							<div class="EduTaxRebateWidgetGovMB__propertySummary--value" v-html="getSchoolTax(x,y)"></div>
						</div>
					</div>


					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
							<span class="EduTaxRebateWidgetGovMB__propertySummary--labelBold" v-html="$t('rebate')"></span>
						</div>
						<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
							<div class="EduTaxRebateWidgetGovMB__propertySummary--valueBold" v-html="getTaxRebate(x,y)"></div>
						</div>
					</div>
				</div>
			</template>
			<div v-if="false" class="EduTaxRebateWidgetGovMB__propertySummary--assessment">
					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRow">
					<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentLeft">
				<span class="EduTaxRebateWidgetGovMB__propertySummary--propertyRebateLabel" v-html="$t('propertyRebate')"></span>
			</div>
			<div class="EduTaxRebateWidgetGovMB__propertySummary--assessmentRight">
				<div class="EduTaxRebateWidgetGovMB__propertySummary--propertyRebateValue" v-html="getPropertyTaxRebate(x)"></div>
			</div>
			</div>
			</div>
		</div>
	</div>
	<div class="EduTaxRebateWidgetGovMB__propertySummary--rightColumn">
		<div v-if="false" class="EduTaxRebateWidgetGovMB__propertySummary--taxHeading" v-html="$t('summaryTaxHeading')"></div>
		<div v-if="false" class="EduTaxRebateWidgetGovMB__propertySummary--taxValue" v-html="getTotalTax()"></div>
		<div class="EduTaxRebateWidgetGovMB__propertySummary--rebateHeading" v-html="$t('summaryRebateHeading')"></div>
		<div class="EduTaxRebateWidgetGovMB__propertySummary--rebateValue" v-html="getTotalTaxRebate()"></div>
		<div class="EduTaxRebateWidgetGovMB__propertySummary--rebateBody" v-html="$t('summaryRebateBody')"></div>
	</div>
</div>
	</div>
</template>

<script>
import Property from '../models/Property'

export default {
	name: 'PropertySummary',
	props: ['value'],
	data() {
		return {
			Property,
			totals: {

			}
		}
	},
	mounted() {

   },
   watch: {
   },
	computed: {
	},
	methods: {
		calculateAll() {

		},
		getMoneyFormat(val) {
			if (val != null) {
				if (!isNaN(val)) {
					return val.moneyFormat(this.$store.state.lang)
				}
			}
			let zero  = 0;
			return zero.moneyFormat(this.$store.state.lang);
		},

		getZeroIfNull(val) {
			if (val != null) {
				return val;
			}
			return 0;
		},
		getTotalTax() {
			let total = 0;
			for (let x = 0; x < this.value.length; x++) {
				for (let y = 0; y < this.value[x].assessment.length; y++) {
					total += this.calculateSchoolTax(x,y);
				}
			}
			return total.moneyFormat(this.$store.state.lang);
		},
		getTotalTaxRebate() {
			let total = 0;
			for (let x = 0; x < this.value.length; x++) {
				for (let y = 0; y < this.value[x].assessment.length; y++) {
					total += this.calculateTaxRebate(this.calculateSchoolTax(x,y),this.value[x].assessment[y].classType) ;
				}
			}

			return total.moneyFormat(this.$store.state.lang);
		},
		getEducationSupportLevy(p,a) {
			let val =  this.value[p].assessment[a].educationSupportLevy.getRawValue();
			if (val == null) {
				val = 0;
			}
			return val.moneyFormat(this.$store.state.lang);
		},

		getPropertySchoolTax(x) {
			let tax = 0;
			for (let y = 0; y < this.value[x].assessment.length; y++) {
				tax += this.calculateSchoolTax(x,y);
			}
			return tax.moneyFormat(this.$store.state.lang);
		},

		getPropertyTaxRebate(x) {
			let total = 0;
			for (let y = 0; y < this.value[x].assessment.length; y++) {
				total += this.calculateTaxRebate(this.calculateSchoolTax(x,y),this.value[x].assessment[y].classType) ;
			}
			return total.moneyFormat(this.$store.state.lang);
		},



		getSchoolTax(p,a) {
			let tax =  this.calculateSchoolTax(p,a);
			return tax.moneyFormat(this.$store.state.lang);
		},
		getTaxRebate(x,y) {
			let tax = this.calculateTaxRebate(this.calculateSchoolTax(x,y),this.value[x].assessment[y].classType) ;
			return tax.moneyFormat(this.$store.state.lang);
		},
		calculateTaxRebate(amount, type) {
			if (amount == null) {
				amount = 0;
			}
			if (type == "otherProperty") {
				return amount * 0.1;
			} else {
				return amount * 0.5;
				// return amount * 0.375;
				// return amount * 0.25;
			}
		},

		calculateSchoolTax(p,a) {
			// console.log("calculateSchoolTax:"+p+","+a);
			let tax = 0;
			let portionedAssessment = 0;
			let schoolDivisionMillRate = 0;
			let educationSupportLevy = 0;
			if (!isNaN(this.value[p].assessment[a].portionedAssessment.getRawValue())) {
				portionedAssessment = parseFloat(this.value[p].assessment[a].portionedAssessment.getRawValue());
			} else {
				portionedAssessment = 0;
			}
			if (this.value[p].assessment[a].classType == "otherProperty") {
				if (!isNaN(this.value[p].assessment[a].educationSupportLevy.getRawValue())) {
					educationSupportLevy = parseFloat(this.value[p].assessment[a].educationSupportLevy.getRawValue());
				}
			}
			if (!isNaN(this.value[p].assessment[a].schoolDivisionMillRate.value)) {
				schoolDivisionMillRate = parseFloat(this.value[p].assessment[a].schoolDivisionMillRate.getRawValue());
			}
			// mill rate can come in

			if (schoolDivisionMillRate <= 0.1 && schoolDivisionMillRate > 0) {
				// dont' need to divide by 1000, as mill rate is already divided.
				tax = (portionedAssessment * (schoolDivisionMillRate + educationSupportLevy));
			} else {
				tax = (portionedAssessment * (schoolDivisionMillRate + educationSupportLevy)) / 1000;
			}

			if (!isNaN(tax)) {
				return tax;
			} else {
				return 0;
			}
		},

		getPropertyHeader(x) {

			if (this.value[x].rollNumber.value != null && this.value[x].rollNumber.value != "") {
				return this.$t('property') + " (" + this.value[x].rollNumber.value + ")";
			} else {
				let num = x + 1;
				return this.$t('property') + " " + num.leftZeroPad(2);
			}
		},
		onRemoveProperty(x) {
			window.$bus.$emit("property:remove", x);
		},
		onAddProperty(x) {
			window.$bus.$emit("property:add");
		},

		onRemoveAssessment(p, a) {
			window.$bus.$emit("assessment:remove", p, a);
		},
		onAddAssessment(p) {
			window.$bus.$emit("assessment:add", p);
		},


		onSend() {
			/*
			if (this.message.value.trim() != "" && this.message.value != null) {
				this.$emit("message:newMessage", {
					message:this.message.value,
					replyToId: this.replyToId.value,
					sourceId: this.sourceId,
					sourceTable: this.sourceTable,
					done: () => {
						this.message.value = "";
					}
				});
			}
			*/
		}
	}
}
</script>
